import { useTranslation } from 'react-i18next';
const LANGS = [
    {
        value: 'pt-BR',
        label: 'Portuguese',
        icon: '/static/icons/ic_flag_pt_br.svg',
    },
    {
        value: 'en',
        label: 'English',
        icon: '/static/icons/ic_flag_en.svg',
    },
];
export function useLocales() {
    const { i18n, t: translate } = useTranslation();
    const langStorage = localStorage.getItem('i18nextLng');
    const currentLang = LANGS.find((_lang) => _lang.value === langStorage) || LANGS[1];
    const handleChangeLanguage = (newlang) => {
        void i18n.changeLanguage(newlang);
    };
    return {
        onChangeLang: handleChangeLanguage,
        translate,
        currentLang,
        allLang: LANGS,
    };
}
//# sourceMappingURL=useLocales.js.map